import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LIENZOS, recolorearFragmentoSvg, } from '../tipos.js';
/**
 * ÚNICO motor de arte (regla 6). Lo montan: el editor de plantillas, el editor del
 * cliente y el renderer del servidor. DOM absoluto, no <canvas> (§5.3): el texto es
 * texto real y React escapa todo — jamás dangerouslySetInnerHTML (regla 12).
 */
function css(relleno) {
    if (!relleno)
        return undefined;
    return relleno.tipo === 'solido'
        ? relleno.color
        : `linear-gradient(${relleno.angulo}deg, ${relleno.desde}, ${relleno.hasta})`;
}
function sombraCss(e) {
    return e.sombra ? `${e.sombra.x}px ${e.sombra.y}px ${e.sombra.desenfoque}px ${e.sombra.color}` : undefined;
}
/** Iconos de canal en SVG inline: el arte no lleva emojis jamás. */
function IconoCanal({ canal, tamano }) {
    const comun = {
        width: tamano,
        height: tamano,
        viewBox: '0 0 24 24',
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: 2,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        style: { flex: 'none' },
    };
    switch (canal) {
        case 'WHATSAPP':
            return (_jsxs("svg", { ...comun, children: [_jsx("path", { d: "M12 3a9 9 0 0 0-7.6 13.8L3 21l4.4-1.3A9 9 0 1 0 12 3Z" }), _jsx("path", { d: "M8.8 9.2c.3 2.6 3.4 5.7 6 6l1.4-1.4-2-1.3-1 .7c-.8-.4-1.9-1.5-2.3-2.3l.7-1-1.3-2-1.5 1.3Z", fill: "currentColor", stroke: "none" })] }));
        case 'INSTAGRAM':
            return (_jsxs("svg", { ...comun, children: [_jsx("rect", { x: "3", y: "3", width: "18", height: "18", rx: "5" }), _jsx("circle", { cx: "12", cy: "12", r: "4" }), _jsx("circle", { cx: "17.2", cy: "6.8", r: "1.1", fill: "currentColor", stroke: "none" })] }));
        case 'FACEBOOK':
            return (_jsx("svg", { ...comun, children: _jsx("path", { d: "M14.5 21v-7h2.6l.4-3h-3V9.1c0-.9.3-1.5 1.6-1.5h1.5V4.9c-.3 0-1.2-.1-2.2-.1-2.2 0-3.7 1.3-3.7 3.8V11H9v3h2.7v7" }) }));
        case 'TIKTOK':
            return (_jsxs("svg", { ...comun, children: [_jsx("path", { d: "M15 4v9.5a4.5 4.5 0 1 1-4.5-4.5" }), _jsx("path", { d: "M15 4c.4 2.4 2 4 4.5 4.3" })] }));
        default:
            return null;
    }
}
export function Poster({ resuelto, escala = 1, atributosElemento }) {
    const lienzo = LIENZOS[resuelto.formato];
    const familias = new Map(resuelto.fuentes.map((f) => [f.fuenteId, f.familia]));
    const estiloLienzo = {
        position: 'relative',
        width: lienzo.w,
        height: lienzo.h,
        overflow: 'hidden',
        backgroundColor: resuelto.fondo.color ?? '#ffffff',
        transform: escala === 1 ? undefined : `scale(${escala})`,
        transformOrigin: 'top left',
        fontFamily: 'Arial, sans-serif',
    };
    const ordenados = [...resuelto.elementos]
        .filter((e) => e.visible)
        .sort((a, b) => a.z - b.z);
    return (_jsxs("div", { style: estiloLienzo, "data-poster-lienzo": true, children: [resuelto.fondo.imagenUrl ? (_jsx("img", { src: resuelto.fondo.imagenUrl, alt: "", style: { position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' } })) : null, ordenados.map((el) => (_jsx(Elemento, { el: el, resuelto: resuelto, lienzo: lienzo, familia: familias.get(idFuente(el) ?? '') ?? 'Arial', extra: atributosElemento?.(el) }, el.id)))] }));
}
function idFuente(el) {
    if (el.tipo === 'texto' || el.tipo === 'precio' || el.tipo === 'contactos')
        return el.fuenteId;
    return null;
}
function Elemento({ el, resuelto, lienzo, familia, extra, }) {
    const caja = {
        position: 'absolute',
        left: `${el.rect.x}%`,
        top: `${el.rect.y}%`,
        width: `${el.rect.w}%`,
        height: `${el.rect.h}%`,
        opacity: el.opacidad,
        transform: el.rotacion ? `rotate(${el.rotacion}deg)` : undefined,
        transformOrigin: 'center center',
    };
    let contenido = null;
    switch (el.tipo) {
        case 'texto': {
            contenido = _jsx(Texto, { el: el, textos: resuelto.textos, nombreNegocio: resuelto.nombreNegocio, familia: familia });
            break;
        }
        case 'producto': {
            const producto = resuelto.productos[el.indice];
            if (!producto)
                return null;
            contenido = (_jsx("img", { src: producto.imagenUrl, alt: producto.referencia, style: {
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain', // nada se deforma (regla 11)
                    borderRadius: el.radio,
                    filter: sombraCss(el) ? `drop-shadow(${sombraCss(el)})` : undefined,
                } }));
            break;
        }
        case 'precio': {
            const producto = resuelto.productos[el.indice];
            if (!producto?.precio)
                return null;
            contenido = _jsx(Precio, { el: el, precio: producto.precio, familia: familia });
            break;
        }
        case 'logoCliente': {
            if (!resuelto.logoClienteUrl)
                return null;
            contenido = (_jsx("div", { style: {
                    width: '100%',
                    height: '100%',
                    background: css(el.fondo),
                    borderRadius: el.radio,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }, children: _jsx("img", { src: resuelto.logoClienteUrl, alt: "", style: { maxWidth: '92%', maxHeight: '92%', objectFit: 'contain' } }) }));
            break;
        }
        case 'vector': {
            const marcado = el.color ? recolorearFragmentoSvg(el.svg, el.color) : el.svg;
            contenido = (_jsx("svg", { viewBox: el.viewBox, preserveAspectRatio: "none", width: "100%", height: "100%", 
                // Excepción justificada a la regla 12: NO es texto de usuario. El markup
                // se valida contra construcciones activas al subirlo y SIEMPRE de nuevo
                // en resolverSpec antes de llegar aquí (motivoSvgInseguro).
                dangerouslySetInnerHTML: { __html: marcado } }));
            break;
        }
        case 'logoMarca': {
            if (!resuelto.logoMarcaUrl)
                return null;
            contenido = (_jsx("div", { style: {
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }, children: _jsx("img", { src: resuelto.logoMarcaUrl, alt: "", style: { maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' } }) }));
            break;
        }
        case 'contactos': {
            const visibles = resuelto.contactos.filter((c) => el.canales.includes(c.canal));
            if (visibles.length === 0)
                return null;
            contenido = (_jsx("div", { style: {
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: el.direccion === 'fila' ? 'row' : 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: el.direccion === 'fila' ? 0 : 4,
                    fontFamily: `'${familia}', Arial, sans-serif`,
                    fontSize: el.tamano,
                    color: el.color,
                    whiteSpace: 'nowrap',
                }, children: visibles.map((c, i) => (_jsxs("span", { style: { display: 'inline-flex', alignItems: 'center', gap: el.tamano * 0.25 }, children: [i > 0 && el.direccion === 'fila' ? el.separador : '', el.mostrarIconos ? _jsx(IconoCanal, { canal: c.canal, tamano: el.tamano * 0.95 }) : null, c.valor] }, `${c.canal}-${i}`))) }));
            break;
        }
        case 'imagen': {
            const url = resuelto.assets[el.assetId];
            if (!url)
                return null;
            contenido = (_jsx("img", { src: url, alt: "", style: { width: '100%', height: '100%', objectFit: el.ajuste, borderRadius: el.radio } }));
            break;
        }
        case 'imagenBase': {
            const url = resuelto.assets[el.id] ?? resuelto.assets['__imagenBase'];
            if (!url)
                return null;
            contenido = (_jsx("img", { src: url, alt: "", style: { width: '100%', height: '100%', objectFit: 'cover' } }));
            break;
        }
        case 'forma': {
            if (el.forma === 'linea') {
                contenido = (_jsx("div", { style: {
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                    }, children: _jsx("div", { style: { width: '100%', height: Math.max(2, el.borde?.grosor ?? 4), background: css(el.relleno) } }) }));
            }
            else {
                contenido = (_jsx("div", { style: {
                        width: '100%',
                        height: '100%',
                        background: css(el.relleno),
                        borderRadius: el.forma === 'circulo' ? '50%' : el.radio,
                        border: el.borde ? `${el.borde.grosor}px solid ${el.borde.color}` : undefined,
                    } }));
            }
            break;
        }
    }
    if (contenido === null)
        return null;
    void lienzo;
    // El editor puede aportar atributos y estilo extra; el estilo se FUSIONA con la caja
    // (si lo pisara, el elemento perdería su posición absoluta).
    const { style: estiloExtra, ...restoExtra } = (extra ?? {});
    return (_jsx("div", { style: { ...caja, ...estiloExtra }, "data-poster-el": el.id, ...restoExtra, children: contenido }));
}
function Texto({ el, textos, nombreNegocio, familia, }) {
    let texto = el.contenido;
    if (el.binding === 'nombreNegocio')
        texto = nombreNegocio || el.contenido;
    else if (el.binding !== 'libre' && textos[el.binding])
        texto = textos[el.binding];
    if (el.transform === 'upper')
        texto = texto.toUpperCase();
    else if (el.transform === 'lower')
        texto = texto.toLowerCase();
    return (_jsx("div", { "data-poster-texto": el.autoAjustar ? 'auto' : 'fijo', "data-max-lineas": el.maxLineas, "data-tamano": el.tamano, style: {
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: el.align === 'left' ? 'flex-start' : el.align === 'right' ? 'flex-end' : 'center',
            textAlign: el.align,
            fontFamily: `'${familia}', Arial, sans-serif`,
            // El tamaño cambia el font-size, jamás scaleX/scaleY (regla 11, §5.5).
            fontSize: el.tamano,
            fontWeight: el.peso,
            fontStyle: el.italic ? 'italic' : 'normal',
            color: el.color,
            lineHeight: el.interlineado,
            textShadow: sombraCss(el),
            WebkitTextStroke: el.trazo ? `${el.trazo.grosor}px ${el.trazo.color}` : undefined,
            overflow: 'hidden',
            overflowWrap: 'break-word',
        }, children: _jsx("span", { style: { width: '100%' }, children: texto }) }));
}
function Precio({ el, precio, familia, }) {
    return (_jsxs("div", { style: {
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            background: css(el.fondo),
            borderRadius: el.radio,
            fontFamily: `'${familia}', Arial, sans-serif`,
            lineHeight: 1.05,
        }, children: [el.estilo === 'antes_ahora' && precio.antes ? (_jsx("span", { style: {
                    fontSize: el.tamanoAntes,
                    color: el.colorAntes,
                    textDecoration: 'line-through',
                }, children: precio.antes })) : null, _jsx("span", { style: { fontSize: el.tamanoAhora, color: el.colorAhora, fontWeight: 800 }, children: precio.ahora })] }));
}
//# sourceMappingURL=Poster.js.map